export default __webpack_public_path__ + "static/assets/6fb101b382b060814f8329ebfd1844bf.svg";